import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Modal } from 'components';
require('./style.css');

interface IProps {
	showHeaderCloseButton?: boolean;
	closeModal?: () => void;
	t?: (key: string) => string;
	baseUrlClient?: string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class LogInAsModal extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.closeModal = this.closeModal.bind(this);
		this.closeModal1 = this.closeModal1.bind(this);
	}

	public closeModal(e: React.SyntheticEvent) {
		e.preventDefault();
		this.props.closeModal();
	}

	public closeModal1() {
		this.props.closeModal();
	}

	public render() {
		const { t, showHeaderCloseButton } = this.props;

		return (
			<Modal showHeaderCloseButton={showHeaderCloseButton} closeModal={this.closeModal1} modalClass="logInAsModal">
				<div>
					<div className="header">
						<h2>{t('Login_Modals_LogInAs_JoinBSPortal')}</h2>
						<span>{t('Login_Modals_LogInAs_JoinBSPortal_Desc')}</span>
					</div>
					<div className="body">
						<div className="infoBox">
							<div className="row getStarted">
								<div className="col-md-4 item">
									<div className="top">
										<a href="#" onClick={this.closeModal}>
											<div className="icon">
												<img src={require('containers/Html/icons/login_user.svg')} />
											</div>
										</a>
									</div>
									<div className="bottom">
										<h2 className="header">{t('Login_Modals_LogInAs_User')}</h2>
										<h3 className="subtitle">{t('Login_Modals_LogInAs_User_Desc')}</h3>
									</div>
								</div>

								<div className="col-md-4 item">
									<div className="top">
										<a href="#" onClick={this.closeModal}>
											<div className="icon">
												<img src={require('containers/Html/icons/login_influencer.svg')} />
											</div>
										</a>
									</div>
									<div className="bottom">
										<h2 className="header">{t('Login_Modals_LogInAs_Influencer')}</h2>
										<h3 className="subtitle">{t('Login_Modals_LogInAs_Influencer_Desc')}</h3>
									</div>
								</div>

								<div className="col-md-4 item">
									<div className="top">
										<a href="#" onClick={this.closeModal}>
											<div className="icon">
												<img src={require('containers/Html/icons/login_shop.svg')} />
											</div>
										</a>
									</div>
									<div className="bottom">
										<h2 className="header">{t('Login_Modals_LogInAs_Shop')}</h2>
										<h3 className="subtitle">{t('Login_Modals_LogInAs_Shop_Desc')}</h3>
									</div>
								</div>
								<div className="clear" />
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}
export { LogInAsModal };
